"use client";
import { useEffect, useState } from "react";
import { Section } from "../ui/Section";
import { Typography } from "../ui";
import { env } from "@/lib/environment";
import Image from "next/image";
import { cn } from "@/lib/utils";

export default function ApplicationSafeguards() {
  const [selectedItem, setSelectedItem] = useState(0);

  const dataList = [
    {
      title: "Secure Login",
      description: "Advanced encryption ensures unauthorized users are deterred.",
      image:
        env.NEXT_PUBLIC_CDN_URL +
        "/images/digital-signage-security/securce-login.wc0AJ1BEd2aj.png",
    },
    {
      title: "Role-Based Access",
      description: "Assign permissions to users, controlling data and tool access.",
      image:
        env.NEXT_PUBLIC_CDN_URL +
        "/images/digital-signage-security/role-based-access.6GuLEOoXIcYv.png",
    },
    {
      title: "Audit Trail",
      description: "Track all platform actions for transparency and accountability.",
      image:
        env.NEXT_PUBLIC_CDN_URL +
        "/images/digital-signage-security/audit-trail.yi_NRIzYqYU8.png",
    },
    {
      title: "Device Protection",
      description: "Devices are locked down to function exclusively as signage players.",
      image:
        env.NEXT_PUBLIC_CDN_URL +
        "/images/digital-signage-security/device-procetion.WNwIKoVOVq8l.png",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setSelectedItem(prev => (prev + 1) % dataList.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [dataList.length]);
  return (
    <Section
      variant="default"
      className="bg-white"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="flex flex-col gap-2">
          <div className="mb-6">
            <Typography variant="h2" as="h2">
              Application Safeguards
            </Typography>
            <Typography variant="body" as="p">
              Our SaaS platform is built with client-side security features to keep your data safe:
            </Typography>
          </div>

          <div className="border-l-4 border-gray-200 pl-4 grid grid-cols-1 gap-8">
          {dataList.map((certification, index) => (
            <div
              key={index}
              className={cn(
                "cursor-pointer text-gray-300 relative",
                selectedItem === index && "text-text-primary"
              )}
              onClick={() => setSelectedItem(index)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  setSelectedItem(index);
                }
              }}
              role="button"
              tabIndex={0}
            >

              <Typography variant="h4" as="h3" className="text-inherit transition-all duration-200">
                {certification.title}
              </Typography>
              <Typography variant="small" as="p" className="text-inherit transition-all duration-200">
                {certification.description}
              </Typography>


              {selectedItem === index && (
                <div className="absolute top-0 left-[-24px] w-3 h-3 bg-accent rounded-full"></div>
              )}
            </div>
          ))}
          </div>
        </div>
        <div className="lg:w-[450px] mx-auto w-full">
          <Image
            src={dataList[selectedItem].image}
            alt={dataList[selectedItem].title}
            title={dataList[selectedItem].title}
            width={500}
            height={500}
            className="w-full h-auto object-cover"
          />
        </div>
      </div>
    </Section>
  );
}
